<template>
  <div>
    <el-table :data="list" style="width: 100%" :header-cell-style="{
      background: '#F3F3F3',
      color: '#1F3349',
      fontSize: '15px',
      fontWeight: 'normal',
    }" :cell-style="{ fontSize: '15px', color: '#666666' }">
      <el-table-column prop="order_no" label="订单号" width="250" />
      <el-table-column prop="amount" label="订单金额" />
      <el-table-column prop="num" label="数量合计" />
      <el-table-column prop="payment_type" label="支付方式">
        <template slot-scope="scope">
          {{ getPayTypeName(scope.row.payment_type) }}
        </template>
      </el-table-column>
      <el-table-column prop="operator.nickname" label="渠道">
        <template #default="scope">
          {{ getChannel_arr(scope.row.channel) }}
        </template>
      </el-table-column>
      <el-table-column prop="operator.nickname" label="操作人" />
      <el-table-column prop="created_at" label="时间" width="200" />
      <el-table-column prop="status" label="状态">
        <template #default="scope">
          {{ getStatusName(scope.row.status) }}
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column fixed="right" align="center" label="操作" width="200">
        <template slot-scope="scope">
          <div class="flex flex_items flex_center">
            <div @click="handleClick(scope.row)" class="main_color pointer page-handle-btn">
              详情
            </div>
            <!-- <div @click="outPay(scope.row)" v-if="role.includes('v1.window.order.refund.ticket')"
              class="main_color pointer page-handle-btn">
              退票
            </div> -->
            <!-- <div class="main_color pointer page-handle-btn" @click="makeup(scope.row)">
              重打小票
            </div> -->
          </div>
        </template>
      </el-table-column>
      <div slot="empty" style="text-align: center;width:100%">
        暂无数据
      </div>
    </el-table>

    <div class="flex flex_end pagination" v-if="total > 10">
      <el-pagination background layout="prev, pager, next,sizes,jumper" :total="total" @current-change="currentChange"
        :current-page="currentPage" :page-size="pageSize" @size-change="pageSizeC">
      </el-pagination>
    </div>

    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="详情"
      :visible.sync="dialogVisible" width="80%">
      <div class="flex flex_end" v-if="order.channel != 'dy'">
        <el-button type="text" @click="outPay()" v-if="role.includes('v1.window.order.refund.ticket')">退票</el-button>
        <el-button type="text" @click="makeup()">重打小票</el-button>
      </div>
      <table>
        <tr>
          <td class="tab-bg">订单号</td>
          <td>{{ order.order_no }}</td>
          <td class="tab-bg">票数</td>
          <td>{{ order.num }}</td>
          <td class="tab-bg">总金额</td>
          <td>{{ order.amount }}</td>
        </tr>
        <tr>
          <td class="tab-bg">下单时间</td>
          <td>{{ order.created_at }}</td>
          <td class="tab-bg">支付方式</td>
          <td>{{ getPayTypeName(order.payment_type) }}</td>
          <td class="tab-bg">渠道</td>
          <td>{{ getChannel_arr(order.channel) }}</td>
        </tr>
        <tr>
          <td class="tab-bg">购票人电话</td>
          <td>{{ order.contact_mobile }}</td>
          <td class="tab-bg">购票人姓名</td>
          <td>{{ order.contacts }}</td>
          <td class="tab-bg">备注</td>
          <td>{{ order.notes }}</td>
        </tr>
        <tr>
          <td class="tab-bg">已退票数量</td>
          <td>{{ order.refundNum }}</td>
          <td class="tab-bg">退款金额</td>
          <td>{{ order.refundPrice }}</td>
          <td class="tab-bg"> </td>
          <td> </td>
        </tr>
      </table>

      <el-tabs v-model="activeName" class="mt20">
        <el-tab-pane label="产品信息" name="1">
          <el-table :data="orderDetail" style="width: 100%" :header-cell-style="{
            background: '#F3F3F3', color: '#1F3349', fontSize: '15px', fontWeight: 'normal',
          }" :cell-style="{ fontSize: '15px', color: '#666666' }">
            <el-table-column prop="ticket.name" label="门票名称" width="200" v-if="order.channel != 'dy'" />
            <el-table-column prop="title" label="门票名称" width="350" v-else />
            <el-table-column prop="price" label="单价" />

            <template v-if="order.channel != 'dy'">
              <el-table-column prop="num" label="总数" />
              <el-table-column prop="num" label="可用数量">
                <template slot-scope="scope">
                  {{ order.status == 3 || order.status == 9 ? 0 : getNum(scope.row.infos, 0) }}
                </template>
              </el-table-column>
              <el-table-column prop="num" label="已用数量">
                <template slot-scope="scope">
                  {{ getNum(scope.row.infos, 1) }}
                </template>
              </el-table-column>
              <el-table-column prop="num" label="已退数量">
                <template slot-scope="scope">
                  {{ getNum(scope.row.infos, -1) }}
                </template>
              </el-table-column>
              <el-table-column prop="play_date" label="游玩时间" width="200" />
            </template>
            <template v-else>
              <el-table-column prop="num" label="数量" />
            </template>

          </el-table>
        </el-tab-pane>
        <el-tab-pane label="票码游客信息" name="2" v-if="order.channel != 'dy'">
          <el-table :data="ticketList" style="width: 100%" :header-cell-style="{
            background: '#F3F3F3', color: '#1F3349', fontSize: '15px', fontWeight: 'normal',
          }" :cell-style="{ fontSize: '15px', color: '#666666' }">
            <el-table-column prop="infos.index" label="序号" width="50" />
            <el-table-column prop="ticket.name" label="门票名称" width="200" />
            <el-table-column prop="infos.sn" label="票码" width="170" />
            <el-table-column prop="price" label="单价" />
            <el-table-column prop="infos.number_people" label="人数" />
            <el-table-column prop="infos.useNum" label="已使用" />
            <el-table-column prop="infos.tourist_code" label="已退数量" width="80">
              <template slot-scope="scope">
                {{ scope.row.infos && scope.row.infos.status == -1 ? '1' : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="infos.tourist_name" label="游客名称" width="120">
              <template slot-scope="scope" v-if="scope.row.infos && scope.row.infos.identities">
                <div v-for="(item, key) in scope.row.infos.identities" :key="key" class="user_msg">
                  {{ item.tourist_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="infos.tourist_name" label="游客电话" width="150">
              <template slot-scope="scope" v-if="scope.row.infos && scope.row.infos.identities">
                <div v-for="(item, key) in scope.row.infos.identities" :key="key" class="user_msg">
                  {{ item.tourist_phone }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="infos.tourist_name" label="游客证件号" width="180">
              <template slot-scope="scope" v-if="scope.row.infos && scope.row.infos.identities">
                <div v-for="(item, key) in scope.row.infos.identities" :key="key" class="user_msg">
                  {{ item.tourist_code }}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="infos.tourist_phone" label="游客电话" />
            <el-table-column prop="infos.tourist_code" label="游客证件号" width="150" /> -->


            <!-- <el-table-column prop="infos.tourist_code" label="可用数量" width="80">
              <template slot-scope="scope">
                {{ scope.row.infos && scope.row.infos.status == 0 ? '1' : '0' }}
              </template>
            </el-table-column>
            <el-table-column prop="infos.tourist_code" label="已用数量" width="80">
              <template slot-scope="scope">
                {{ scope.row.infos && scope.row.infos.status == 1 ? '1' : '0' }}
              </template>
            </el-table-column> -->

            <!-- <el-table-column prop="play_date" label="时间" width="120" /> -->
            <div slot="empty" style="text-align: center;width:100%">
              暂无数据
            </div>
          </el-table>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>


  </div>
</template>
<script>
import { getStatusName } from '@/utils/index'
export default {
  props: {
    endTime: {
      default: ''
    },
    startTime: {
      default: ''
    },
    order_no: {
      default: ''
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pay_type: [],
      role: [],
      order: {},
      dialogVisible: false,
      orderDetail: [],
      activeName: '1',
      ticketList: [],
      pageSize: 10,
      getStatusName: getStatusName,
      channel_arr: []
    }
  },
  created() {
    this.role = this.$store.getters.roles ? this.$store.getters.roles : [];
    // this.handleClick({ id: 46 })
  },
  methods: {
    resetData() {
      this.currentPage = 1;
      this.getList()
    },
    currentChange(e) {
      this.currentPage = e
      this.getList();
    },
    pageSizeC(e) {
      this.pageSize = e;
      this.getList()
    },
    getList() {
      this.api.getUrl('/api/v1/window/order/tickets', {
        size: this.pageSize,
        page: this.currentPage,
        keyword: this.keyword,
        startTime: this.startTime,
        // startTime: '2025-04-09',
        endTime: this.endTime,
        order_no: this.order_no
      }, { loading: true })
        .then((res) => {
          this.list = res.list;
          this.pay_type = res.pay_type;
          this.total = res.meta.total;
          this.channel_arr = res.channel_arr;
        });
    },
    getPayTypeName(s) {
      if (this.pay_type.length > 0 && s) {
        let k = this.pay_type.filter(r => r.key == s)[0];
        return k ? k.name : ''
      }
      return ''
    },
    handleClick(s) {
      this.order = {}
      this.api.getUrl('/api/v1/window/order/tickets/detail/' + s.id, {}, { loading: true }).then(res => {
        this.dialogVisible = true;
        this.activeName = '1'
        this.order = res.order;
        let refundNum = 0;
        let refundPrice = 0;
        this.orderDetail = res.order.detail;
        this.ticketList = [];
        this.orderDetail.map(r => {
          let obj = JSON.parse(JSON.stringify(r));
          if (r.infos) {
            r.infos.map(s => {
              obj = JSON.parse(JSON.stringify(r));
              obj.infos = JSON.parse(JSON.stringify(s));
              this.ticketList.push(obj)
              if (s.status == -1) {
                refundPrice += Number(s.price)
              }
            })
            refundNum += this.getNum(r.infos, -1);
          }
        })
        this.order.refundNum = refundNum;
        this.order.refundPrice = refundPrice;
        console.log(this.orderDetail);

      })

    },
    makeup(s) {
      this.api.getUrl('/api/v1/window/printerStatus').then(res => {
        if (res.status != 1) {
          this.$alert('<strong style="color:#ed2222;">打印机没有连接</strong>', '注意！', {
            dangerouslyUseHTMLString: true,
            showClose: false
          });
        } else if (res.status == 1) {
          this.api.postUrl('/api/v1/window/order/makeup/' + this.order.id, {}, { loading: true }).then(res => {
            this.$message.success('操作成功')
          })
        }
      })
    },
    outPay(e) {
      this.$router.push('/refundTicket?search=' + this.order.order_no)
    },
    getNum(r, status) {
      let l = r ? r.filter(s => s.status == status).length : '';
      return l;
    },
    getChannel_arr(s) {
      return this.channel_arr[s]
    },


  }
}
</script>
<style scoped>
table {
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  width: 100%;
  border-collapse: collapse;
}

td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  height: 45px;
  padding: 5px;
}

.tab-bg {
  background: #fafafa;
  width: 10%;
}

td {
  width: 20%;
}
.user_msg {
  min-height: 25px;
}
</style>
